import { useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import { Clear as ClearIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { useDropzone } from "react-dropzone";
import FlexibleWidthDialog from "../Dialog/FlexibleWidthDialog";
import CropImage from "./CropIMage";

export default function ImageManager({ open, actionClose, multipleImages = false, setImages }) {

  const [filesDND, setFilesDND] = useState([])
  const { getRootProps, getInputProps } = useDropzone({
    accept: { 'image/*': [] },
    multiple: multipleImages,
    onDrop: (acceptedFiles) => {

      const acceptedFilesFormat = acceptedFiles.map((file) => {
        return {
          file: file,
          size: file.size,
          type: file.type,
          name: file.name
        }
      })

      if (multipleImages) {
        const filesPrevious = [...filesDND]
        filesPrevious.push(...acceptedFilesFormat)
        setFilesDND(filesPrevious);
        console.log("filesPrevious", filesPrevious)
      } else {
        setFilesDND(acceptedFilesFormat);
        console.log("acceptedFilesFormat", acceptedFilesFormat)
      }
    }
  })

  useEffect(() => {
    console.log("filesDND", filesDND)
  }, [filesDND])

  const handleClearImage = () => { setFilesDND([]) }

  /* cropped image */
  const [openCropImageDialog, setOpenCropImageDialog] = useState(false)
  const [imageToCrop, setImageToCrop] = useState(null)
  const [imageToCropMetadata, setImageToCropMetadata] = useState(null)
  const [imagePositionToCrop, setImagePositionToCrop] = useState(null)
  const handleSeletectImageToCrop = (item, position) => {
    setImagePositionToCrop(position)
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result //.replace('data:', '').replace(/^.+,/, '');
      //console.log(base64String);
      setImageToCrop(base64String)
      setImageToCropMetadata({ type: item.type, name: item.name })
      setOpenCropImageDialog(true)
    };
    reader.readAsDataURL(item.file);
  }
  const handleCloseCropImegeDialog = () => setOpenCropImageDialog(false)
  const handleReceiveCroppedImage = (image) => {
    //console.log("handleReceiveCroppedImage", image)
    const filesPrevious = [...filesDND]
    filesPrevious[imagePositionToCrop] = {
      file: image,
      size: image.size,
      type: image.type,
      name: image.name
    }
    setFilesDND(filesPrevious);
    setOpenCropImageDialog(false)
  }

  /* Actions over filesDND (wait list to upload) */
  const handleDeleteFileDND = (index) => {
    const filesPrevious = [...filesDND]
    filesPrevious.splice(index, 1)
    setFilesDND(filesPrevious);
  }

  //const handleValidateAspectRatio = async(file, w, h) => await hasAspectRatio(file, w, h)

  const Actions = () => (<>
    <Button onClick={() => { setImages(filesDND); actionClose(false); }} disabled={filesDND.length === 0} >Seleccionar</Button>
    <Button onClick={() => { setFilesDND([]); actionClose(false); }}>Cerrar</Button>
  </>)

  return (<>
    <FlexibleWidthDialog open={open} title="Administrador de Imagen" actions={<Actions />}>
      <div className="im-images-actions-container">
        <div className="im-images-actions-upload">
          <section className="container">
            <div {...getRootProps({ className: 'dropzone' })} style={{ border: "1px dashed gray", padding: 10 }}>
              <input {...getInputProps()} />
              <p>Arrastra y suelta los archivos aquí o da clic para seleccionar los archivos</p>
            </div>
            {filesDND.length > 0 ?
              <div style={{ marginTop: 12 }}>
                <Button variant="outlined" size="small" startIcon={<ClearIcon />} onClick={handleClearImage}> Cancelar </Button>
                <h4>Archivos</h4>
                <Grid container spacing={2} sx={{ height: 200, overflow: "scroll" }}>
                  {filesDND.map((item, index) => (
                    <Grid key={item.file.path} item xs={12}>
                      <div style={{ display: "flex" }}>
                        <div>
                          <Button><DeleteIcon color="error" onClick={() => handleDeleteFileDND(index)} /></Button>
                        </div>
                        <img src={URL.createObjectURL(item.file)} alt={item.file.path} style={{ maxWidth: "100px", height: "fit-content" }} />
                        <div style={{ textAlign: "left", paddingLeft: 10 }}>
                          <div style={{ fontSize: 12 }}>{(item.file.size / 1024).toFixed(2)} KB</div>
                          {item.file.size > 300000 ? <div style={{ fontSize: 12, color: "red" }}>El peso de la imagen no debe ser mayor a 300 KB</div> : null}
                          <div><Button onClick={() => handleSeletectImageToCrop(item, index)}>Reestructurar</Button></div>
                        </div>
                      </div>
                    </Grid>
                  ))}
                </Grid>
              </div>
              : null}
          </section>
        </div>
      </div>
    </FlexibleWidthDialog>
    <CropImage
      open={openCropImageDialog}
      image={imageToCrop}
      imageMetadata={imageToCropMetadata}
      close={handleCloseCropImegeDialog}
      returnImageCropped={handleReceiveCroppedImage} />
  </>)
}

//https://blog.openreplay.com/image-manipulation-with-react-easy-crop/
//https://www.w3docs.com/snippets/html/how-to-display-base64-images-in-html.html
//https://pqina.nl/blog/convert-a-file-to-a-base64-string-with-javascript/
//https://pqina.nl/blog/convert-a-blob-to-a-file-with-javascript/